var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Echart',{staticStyle:{"margin-top":"10px"},attrs:{"options":_vm.options,"id":"centreLeft1Chart","height":"200px","width":"260px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }